import React from 'react'
import PropTypes from 'prop-types'
import { GenerateLink, PlayBtn } from 'scripts/helpers/AppHelper'

function ImageComponent(props) {
  if (props.id && props.slug) {
    const {id, slug, title, imageComponent, customOnClick} = props
    const titleText = title.text || null
    return (
      <div className="pos-relative">
        <GenerateLink id={id} slug={slug} title={titleText} type="post" element={imageComponent} customOnClick={customOnClick}/>
        <PlayBtn {...props} />
      </div>
    )
  } else {
    return (
      <div className="overflow-hidden">
        {props.imageComponent}
      </div>
    )
  }
}

function FeaturedBanner(props) {
  const featuredMetaClass = props.featuredMetaClass || 'featured-meta-accent'
  const bannerClass = props.bannerClass || `featured-meta ${featuredMetaClass}`
  const wrapperClass = `featured-wrapper ${props.wrapperClass}` || 'featured-wrapper'

  return (
    <div className={`${wrapperClass}`}>
      <ImageComponent {...props} imageComponent={props.imageComponent} />
      <div className={`${bannerClass}`}>
        {props.children}
      </div>
    </div>
  )
}

FeaturedBanner.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  slug: PropTypes.string,
  images: PropTypes.object,
  imageComponent: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  featuredMetaClass: PropTypes.string
}

module.exports = FeaturedBanner



// WEBPACK FOOTER //
// ./assets/js/components/featured/FeaturedBanner.jsx